import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { FavoritosProvider } from '../../providers/favoritos';
import { Componentes } from '../../providers/componentes';
import { ProdutoPage } from '../produto/produto';
import { Autenticacao } from '../../providers/autenticacao';
import { Storage } from '@ionic/storage';

@Component({
  selector: 'page-favoritos',
  templateUrl: 'favoritos.html',
})
export class FavoritosPage {

  items: any = []
  loading: boolean = true
  defaultImage: any = "./assets/images/img-loading.png"

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public favoritosProvider: FavoritosProvider,
    public componentes: Componentes,
    public autenticacao: Autenticacao,
    public storage: Storage) {
  }

  ionViewDidLoad() {
    this.storage.get('token').then(token => {
      if (!token) {
        this.navCtrl.push('LoginPage');
      } else {
        this.loading = true;
        this.favoritosProvider.refresh();
        this.favoritosProvider.favoritos(this.autenticacao.getUserId()).then(
          data => {
            this.items = data;
            this.loading = false;
          }, err => {
            this.componentes.apresentaToast('Não foi possível buscar os seus favoritos. Verifique a sua conexão e texte novamente.');
            this.loading = false;
          }
        )
      }
    })
  }

  exibeProduto(item) {
    this.navCtrl.push(ProdutoPage, { produto: item, categoria: false });
  }
}



// WEBPACK FOOTER //
// ./src/pages/favoritos/favoritos.ts